<app-main-nav-bar></app-main-nav-bar>
<div class="main">
  <div class="wrap">
    <div class="intro elem" *ngIf="!requests || !requests.length">
      <div class="row">
        <div class="col col-12">
          <div class="head">
            <img src="/Content/src/img/more/bime-intro.png" width="200" class="image">
            <h2>هشتگ بیمه</h2>
          </div>
          <div class="txt-center">
            <h3>دستیار شخصی بیمه</h3>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col-6">
          <a href="javascript:void(0);" class="btn btn-next">
            <span>خرید بیمه {{settings.translateEnglish(productName, translation)}}</span>
          </a>
        </div>
        <div class="col col-6">
          <a href="javascript:void(0);" class="btn btn-request">
            <span>بیمه &zwnj;های من</span>
          </a>
        </div>
      </div>
    </div>
    <div class="request elem" style="display: block;">
      <div class="row">
        <div class="col col-12">
          <div class="head">
            <h2>بیمه نامه&zwnj;ها من</h2>
            <p>درخواست&zwnj;های {{settings.translateEnglish(productName, translation)}}</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col-12">
          <div class="list">
            <div *ngFor="let request of requests" class="item" data-request="566">
              <div class="avatar" [ngClass]="request.status || ''" ><i class="icon {{request.icon}}"></i></div>
              <div class="pull-left" style="margin-left: 0; margin-top: 0">
                <div class="controll">
                  <button (click)="openDialog(request.id)" class="btn4 btn-delete"
                          data-person="fyvb73c" style="margin-left: 19px; border:lightgray;border-radius: 100%;height: 27px;">
                    <i class="icon ico-trash-2-outline"></i></button>
                </div>
              </div>
              <div class="text" style="text-align: right" (click)="getDetails(request)"><h2>درخواست {{settings.translateEnglish(productName, translation)}}</h2><span>{{request.id}}</span>
                <div class="sub-count">
                  <div class="text"  [ngClass]="request.status || ''"><i class="icon ico-calendar-outline"></i>
                    <span>{{request.date}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col-12">
          <app-custom-button [HideMainButton]="false"
                             [LabelText]="'درخواست جدید'"
                             [Show]="true"
                             [BackButton]="true"
                             [disabled]="false"
                             (OnClick)="newRequest()"
                             (OnGoBack)="goBack()"
          ></app-custom-button>
        </div>
      </div>
    </div>
  </div>
</div>
